/**
 * KDS Progress Circle — Figma Data Table chart cell (node 663:20233).
 *
 * - Track: neutral.100, 3px stroke
 * - Range: brand.500, 3px stroke, butt cap (flat edge)
 * - Size: 29×29 SVG viewBox → Chakra `sm` (32px) is the closest preset
 *
 * Chakra size presets: xs=24/4, sm=32/5, md=40/6, lg=48/7, xl=64/8.
 * Figma uses 3px thickness — override via `--thickness` CSS variable.
 */

/** Default track stroke color. */
export const progressCircleTrackColor = 'neutral.100';

/** Default range stroke color. */
export const progressCircleRangeColor = 'brand.500';

/** Default Chakra size preset. */
export const progressCircleDefaultSize = 'sm' as const;

/** Figma stroke width (3px) — applied via `--thickness` CSS variable. */
export const progressCircleThickness = '3px';
